import React, { useState } from "react";
import { Box, Typography, Select, MenuItem, Button, Paper, InputLabel, FormControl } from "@mui/material";
import MapView from "./components/MapView";
import CameraView from "./components/CameraView";
import ConsolidatedControlPanel from "./components/ConsolidatedControlPanel";
import AlertPanel from "./components/AlertPanel";
import MapIcon from '@mui/icons-material/Map';
import VideocamIcon from '@mui/icons-material/Videocam';

import ApiConfig from '../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../utils/hooks';

export default function RobotControl() {

  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak);
  const apiConfig = a.api()
  const [selectedRobotId, setSelectedRobotId] = useState("");
  const [viewMode, setViewMode] = useState("map"); // "map" or "camera"
  const [robots, setRobots] = useState([]);

  const selectedRobot = robots.find(r => r.Id === selectedRobotId);

  useMountEffect(() => {
    retrieveRobots();
  }, []);

  const retrieveRobots = () => {
    setRobots([])
    // setRobotStatus([])
    // setRobotLaser([])
    Promise.all([
      apiConfig.fetchRobotData(0)
    ]).then(results => {
        console.log(results[0].RobotResponse)
        setRobots(results[0].RobotResponse || []);

    }).catch(error => {
        console.error(error);
    });
  }

  return (
    <Box sx={{ height: "calc(100vh - 64px)", width: "calc(100% + 48px)", mx: -3, mt: -3, mb: -3, display: "flex", flexDirection: "column", bgcolor: "background.default", overflow: "hidden" }}>
      {/* Header */}
      <Paper elevation={2} sx={{ bgcolor: "grey.900", borderBottom: 1, borderColor: "grey.800", px: 3, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexShrink: 0 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="h5" fontWeight="bold" color="white">
            Robot Control Center
          </Typography>
          <FormControl variant="outlined" size="small" sx={{ minWidth: 220, bgcolor: "grey.800", borderRadius: 1 }}>
            <InputLabel id="robot-select-label" sx={{ color: "white" }}>Select a robot</InputLabel>
            <Select
              labelId="robot-select-label"
              value={selectedRobotId}
              onChange={e => setSelectedRobotId(e.target.value)}
              label="Select a robot"
              sx={{ color: "white", ".MuiOutlinedInput-notchedOutline": { borderColor: "grey.700" } }}
            >
              {robots.map(robot => (
                <MenuItem key={robot.Id} value={robot.Id}>
                  {robot.RobotId}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {selectedRobot && (
          <Box display="flex" alignItems="center" gap={2}>
            <Button
              onClick={() => setViewMode("map")}
              variant={viewMode === "map" ? "contained" : "outlined"}
              startIcon={<MapIcon />}
              sx={viewMode === "map"
                ? { bgcolor: "#0097a7", color: "white", "&:hover": { bgcolor: "#00838f" } }
                : { borderColor: "grey.600", color: "grey.300", "&:hover": { borderColor: "white", color: "white" } }
              }
            >
              Map View
            </Button>
            <Button
              onClick={() => setViewMode("camera")}
              variant={viewMode === "camera" ? "contained" : "outlined"}
              startIcon={<VideocamIcon />}
              sx={viewMode === "camera"
                ? { bgcolor: "#0097a7", color: "white", "&:hover": { bgcolor: "#00838f" } }
                : { borderColor: "grey.600", color: "grey.300", "&:hover": { borderColor: "white", color: "white" } }
              }
            >
              Camera View
            </Button>
          </Box>
        )}
      </Paper>

      {/* Main Content with Overlays */}
      <Box sx={{ flex: 1, position: "relative", overflow: "hidden", minHeight: 0 }}>
        {selectedRobot ? (
          <>
            {/* View Area */}
            <Box sx={{ position: "absolute", inset: 0, overflow: "hidden" }}>
              {viewMode === "map" ? (
                <MapView robot={selectedRobot} apiConfig={apiConfig}/>
              ) : (
                <CameraView robot={selectedRobot}/>
              )}
            </Box>

            {/* Consolidated Control Panel Overlay */}
            <ConsolidatedControlPanel
              robot={selectedRobot}
              // robots={robots}
              apiConfig={apiConfig}
            />
            <AlertPanel
              robot={selectedRobot}
              apiConfig={apiConfig}
            />
          </>
        ) : (
          <Box display="flex" alignItems="center" justifyContent="center" height="100%">
            <Paper sx={{ bgcolor: "grey.900", border: 1, borderColor: "grey.800", borderRadius: 2, p: 6 }}>
              <Typography color="grey.500" align="center">
                Select a robot to begin
              </Typography>
            </Paper>
          </Box>
        )}
      </Box>
    </Box>
  );
}